var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenShotButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15445",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15445",
    transform: "translate(-18674 -4238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15444",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15444",
    transform: "translate(106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_9408",
    "data-name": "\\u9577\\u65B9\\u5F62 9408",
    width: 53,
    height: 53,
    transform: "translate(18568 4238)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(18679 4243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20950",
    "data-name": "\\u30D1\\u30B9 20950",
    d: "M13.81,2.612a7.918,7.918,0,1,1-11.2,0,7.918,7.918,0,0,1,11.2,0",
    transform: "translate(12.904 12.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20951",
    "data-name": "\\u30D1\\u30B9 20951",
    d: "M30.353,0H11.877A11.89,11.89,0,0,0,0,11.877V30.353A11.89,11.89,0,0,0,11.877,42.231H30.353A11.89,11.89,0,0,0,42.231,30.353V11.877A11.89,11.89,0,0,0,30.353,0ZM21.115,31.673A10.558,10.558,0,1,1,31.673,21.115,10.569,10.569,0,0,1,21.115,31.673ZM32.993,10.558a1.32,1.32,0,1,1,1.32-1.32A1.32,1.32,0,0,1,32.993,10.558Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShotButton);
export default __webpack_public_path__ + "static/media/screenShotButton.f3abef0574e8441b384f1feed73ba982.svg";
export { ForwardRef as ReactComponent };